import React, { useEffect } from 'react';

// Icona "?" con tooltip esplicativo, da mettere accanto al titolo di un'area.
// Il tooltip appare su hover E su focus da tastiera (accessibile).
// Autosufficiente: inietta i propri stili una volta sola (usa i token del design
// system gia' definiti su :root/.light/.dark), cosi' non dipende da App.css.

const STYLE_ID = 'help-tip-styles';
const CSS = `
.help-tip { position: relative; display: inline-flex; vertical-align: middle; }
.help-tip-btn {
  display: inline-grid; place-items: center; width: 20px; height: 20px; padding: 0;
  border: none; background: none; color: var(--text-muted); cursor: help; border-radius: 50%;
  transition: color .18s ease, background .18s ease;
}
.help-tip-btn:hover, .help-tip-btn:focus-visible { color: var(--hiplaas-orange); background: var(--glass-brand); }
.help-tip-pop {
  position: absolute; top: calc(100% + 8px); left: 0; z-index: 25;
  width: max-content; max-width: 300px; padding: .65rem .8rem;
  background: var(--bg-glass-strong);
  backdrop-filter: blur(var(--blur)); -webkit-backdrop-filter: blur(var(--blur));
  border: 1px solid var(--border-default); border-radius: 10px;
  box-shadow: 0 8px 24px var(--shadow-color);
  color: var(--text-secondary); font-size: .8rem; font-weight: 400; line-height: 1.45;
  text-transform: none; letter-spacing: normal;
  opacity: 0; visibility: hidden; transform: translateY(-4px);
  transition: opacity .16s ease, transform .16s ease, visibility .16s; pointer-events: none;
}
.help-tip:hover .help-tip-pop, .help-tip:focus-within .help-tip-pop { opacity: 1; visibility: visible; transform: none; }
@media (max-width: 560px) { .help-tip-pop { max-width: 260px; } }
`;

function ensureStyles() {
  if (typeof document === 'undefined' || document.getElementById(STYLE_ID)) return;
  const s = document.createElement('style');
  s.id = STYLE_ID;
  s.textContent = CSS;
  document.head.appendChild(s);
}

function HelpTip({ text, label = 'Cosa fa questa area' }) {
  useEffect(ensureStyles, []);
  return (
    <span className="help-tip">
      <button type="button" className="help-tip-btn" aria-label={label}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <path d="M9.1 9a3 3 0 1 1 5.8 1c0 2-3 2.5-3 4" />
          <line x1="12" y1="17" x2="12" y2="17" />
        </svg>
      </button>
      <span className="help-tip-pop" role="tooltip">{text}</span>
    </span>
  );
}

export default HelpTip;
